/** @jsxImportSource solid-js */
import type { JSX } from "solid-js";
import { WidgetIcon } from "./widget-icon";

/** Shared card textarea styling - composer and pin editor must not drift. */
export const CARD_TEXTAREA_CLASS =
  "text-pl-foreground box-border block max-h-40 w-full resize-none overflow-y-auto border-0 bg-transparent px-3.5 pt-3 pb-1 font-[inherit] text-base leading-normal focus:outline-none sm:text-sm";

/** The drag grip both annotation cards place next to their primary action. */
export function WidgetBubbleGrip(props: { onDragStart?: (e: PointerEvent) => void }): JSX.Element {
  return (
    <button
      type="button"
      data-pl-bubble-drag=""
      aria-label="Drag annotation editor"
      title="Drag annotation editor"
      class="text-pl-muted-foreground hover:bg-pl-foreground/[0.07] hover:text-pl-foreground grid h-8 w-8 shrink-0 cursor-grab touch-none place-items-center rounded-full border-0 bg-transparent active:cursor-grabbing"
      onPointerDown={(e) => props.onDragStart?.(e)}
    >
      <WidgetIcon name="gripVertical" size={14} />
    </button>
  );
}
